import React from 'react';
import { Box, Typography } from '@mui/material';
import { FaExclamationCircle } from 'react-icons/fa';

export interface AlertBannerProps {
  message?: React.ReactNode;
  show: boolean;
}

const AlertBanner: React.FC<AlertBannerProps> = ({ message, show = true }) => {
  if (!show) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: '12px 16px',
        backgroundColor: 'rgba(237, 85, 101, 0.23)',
        borderRadius: '4px',
        boxSizing: 'border-box',
      }}
    >
      <FaExclamationCircle 
        style={{ 
          color: '#ED5565', 
          fontSize: '16px', 
          marginRight: '12px',
          flexShrink: 0,
        }} 
      />
      <Typography
        component="div"
        sx={{
          fontFamily: "'Open Sans', sans-serif",
          fontWeight: 400,
          fontSize: '11.5px',
          lineHeight: '16px',
          color: '#454545',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default AlertBanner;